import React, { useEffect, useMemo, useReducer, useState } from 'react'
import { TreeSelect } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { isEmpty } from 'lodash'
const { SHOW_CHILD } = TreeSelect

const FormatOperation = (state, action) => {
  switch (action.type) {
    case 'key_field':
      return action?.payload?.map((parent, idxParent) => {
        const Key_parent = `0-${idxParent}`
        const handleArrayLV1 = []

        // #################### ^^ Parent Section ^^ ################

        if (parent.children !== null) {
          parent?.children?.map((childrenLV1, idxLV1) => {
            const Key_ChildrenLV1 = `0-${idxParent}-${idxLV1}`
            const handleArrayLV2 = []

            // @@@@@@@@@@@@@@@@@@@@ ^^ Children level 1 Section ^^ @@@@@@@@@@@@@@@@@@

            if (childrenLV1.children !== null) {
              childrenLV1.children?.map((childrenLV2, idxLV2) => {
                const Key_ChildrenLV2 = `0-${idxParent}-${idxLV1}-${idxLV2}`
                const state_childrenLV2 = {
                  ...childrenLV2,
                  key: Key_ChildrenLV2,
                  disabled: false,
                }
                handleArrayLV2.push(state_childrenLV2)
              })
            }

            const state_childrenLV1 = {
              ...childrenLV1,
              key: Key_ChildrenLV1,
              disabled: true,
              children: handleArrayLV2.length === 0 ? null : handleArrayLV2,
            }

            handleArrayLV1.push(state_childrenLV1)
          })
        }
        const state_parent = {
          ...parent,
          key: Key_parent,
          disabled: true,
          children: handleArrayLV1.length === 0 ? null : handleArrayLV1,
        }

        return state_parent
      })

    default:
      return state
  }
}
const SubOper = (props) => {
  const {
    choiceCompany,
    choiceOperation,
    choiceSubOperation,
    setChoiceSubOperation,
    masterData,
    selectedSubOperationData,
    defaultSubOperationName,
    setAccountOptions,
    RebaseCutterFunctionally,
    disabled,
  } = props
  const [operation, dispatch] = useReducer(FormatOperation, masterData)
  // const [expandkeys, setExpandKeys] = useState(['0-0-0'])
  const [treeData, setTreeData] = useState(operation) // can fixed syntax "treeData"
  let url_page = window.location.pathname

  const defaultSubOperationNames = useMemo(() => {
    return String(defaultSubOperationName || '')
      .split(',')
      .map((item) => item.trim())
      .filter((item) => item)
  }, [defaultSubOperationName])

  const defaultSubOperationLabelById = useMemo(() => {
    return (choiceSubOperation || []).reduce((result, item, index) => {
      const subOperationName = defaultSubOperationNames[index]

      if (subOperationName) {
        result[item?.toString()] = subOperationName
      }

      return result
    }, {})
  }, [choiceSubOperation, defaultSubOperationNames])

  const getDefaultSubOperationLabel = (value) => {
    return defaultSubOperationLabelById[value?.toString()] || value
  }

  const getSelectedSubOperationLabel = (value) => {
    const selectedItem = selectedSubOperationData?.find(
      (item) => item?.id?.toString() === value?.toString(),
    )

    if (selectedItem) {
      const subOperationName =
        selectedItem.sub_operation_name || selectedItem.name_th || selectedItem.name
      return subOperationName
    }

    return getDefaultSubOperationLabel(value)
  }

  const getTagDisplayLabel = (label, value) => {
    const hasLabel = label !== undefined && label !== null && label !== ''
    if (hasLabel) {
      const isPrimitiveLabel = ['string', 'number'].includes(typeof label)
      if (!isPrimitiveLabel) {
        return label
      }

      const labelText = String(label).trim()
      const valueText = String(value).trim()

      if (labelText !== valueText) {
        return label
      }
    }

    return getSelectedSubOperationLabel(value)
  }

  const renderTag = (event, labelText) => {
    const { closable, onClose } = event

    return (
      <span
        className="ant-select-selection-item"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          maxWidth: '100%',
        }}
      >
        <span className="ant-select-selection-item-content">{labelText}</span>
        {closable ? (
          <span
            className="ant-select-selection-item-remove"
            onMouseDown={(e) => e.preventDefault()}
            onClick={onClose}
            role="button"
            tabIndex={0}
          >
            <CloseOutlined />
          </span>
        ) : null}
      </span>
    )
  }

  useEffect(() => {
    if (masterData.length >= 1) {
      dispatch({ type: 'key_field', payload: masterData })
    }
  }, [masterData])

  useEffect(() => {
    const newListOperations = operation.filter((item) => {
      if (choiceCompany?.includes(item?.value)) {
        return item
      }
    })

    const newListSubOperations = newListOperations?.map((parent) => {
      const arraySaveOperationsList = []
      parent.children?.map((childLv1) => {
        if (choiceOperation?.includes(childLv1.value)) {
          arraySaveOperationsList.push(childLv1)
        }
      })
      const newObjectOper = {
        ...parent,
        children: arraySaveOperationsList.length === 0 ? null : arraySaveOperationsList,
      }
      return newObjectOper
    })

    const FilterNotShowCompany = newListSubOperations?.filter(
      (parent) => parent.children !== null,
    )
    setTreeData(FilterNotShowCompany)

    if (FilterNotShowCompany.length !== 0 && choiceSubOperation?.length !== 0) {
      const selectedSubOperationsList = []
      const newSelectedSubOperations = newListSubOperations?.map((parent) => {
        parent.children?.map((childLv1) => {
          childLv1.children?.map((childLv2) => {
            if (choiceSubOperation.includes(childLv2.value)) {
              selectedSubOperationsList.push(childLv2.value)
            }
          })
        })
      })
      setChoiceSubOperation(selectedSubOperationsList)
    }
  }, [choiceCompany, choiceOperation, operation])

  function onChange(value) {
    setAccountOptions([])
    RebaseCutterFunctionally('from suboperation', choiceCompany, choiceOperation, value)
    setChoiceSubOperation(value)
  }

  const tProps = {
    treeData, // can fixed syntax "treeData"
    value: choiceSubOperation,
    onChange: onChange,
    treeCheckable: true,
    showCheckedStrategy: SHOW_CHILD,
    placeholder: 'Select Project type',
    style: {
      width: '100%',
    },
  }

  return !url_page.includes('/management/powerbi') &&
    !url_page.includes('/create-project') &&
    !url_page.includes('/information') ? (
    <TreeSelect
      size="large"
      treeDefaultExpandAll={true} //เปิด Children ทุกอัน ตอนเริ่มต้น
      {...tProps}
      maxTagCount={0}
      maxTagPlaceholder={(event) => {
        if (choiceSubOperation?.length > 1) {
          return 'Multi select project type'
        }

        return getTagDisplayLabel(event[0]?.label, event[0]?.value)
      }}
      disabled={isEmpty(choiceOperation)}
      tagRender={(event) => {
        const { label, value } = event
        if (choiceSubOperation?.length > 1) {
          return renderTag(event, 'Multi select project type')
        }
        return renderTag(event, getTagDisplayLabel(label, value))
      }}
    />
  ) : (
    <TreeSelect
      size="large"
      // treeDefaultExpandedKeys={expandkeys}
      treeDefaultExpandAll={true} //เปิด Children ทุกอัน ตอนเริ่มต้น
      {...tProps}
      disabled={disabled}
      tagRender={(event) => {
        const { label, value } = event
        return renderTag(event, getTagDisplayLabel(label, value))
      }}
    />
  )

  // }
}

export default SubOper
